/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
    Int32IdAndLabel,
    Int32IdAndLabelFromJSON,
    Int32IdAndLabelFromJSONTyped,
    Int32IdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface AncillaryManagerListItem
 */
export interface AncillaryManagerListItem {
    /**
     * 
     * @type {string}
     * @memberof AncillaryManagerListItem
     */
    id?: string;
    /**
     * 
     * @type {Int32IdAndLabel}
     * @memberof AncillaryManagerListItem
     */
    ancillaryCategory?: Int32IdAndLabel;
    /**
     * 
     * @type {GuidIdAndLabel}
     * @memberof AncillaryManagerListItem
     */
    ancillary?: GuidIdAndLabel;
    /**
     * 
     * @type {GuidIdAndLabel}
     * @memberof AncillaryManagerListItem
     */
    apiName?: GuidIdAndLabel;
    /**
     * 
     * @type {boolean}
     * @memberof AncillaryManagerListItem
     */
    allowEdit?: boolean;
}

export function AncillaryManagerListItemFromJSON(json: any): AncillaryManagerListItem {
    return AncillaryManagerListItemFromJSONTyped(json, false);
}

export function AncillaryManagerListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): AncillaryManagerListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'ancillaryCategory': !exists(json, 'ancillaryCategory') ? undefined : Int32IdAndLabelFromJSON(json['ancillaryCategory']),
        'ancillary': !exists(json, 'ancillary') ? undefined : GuidIdAndLabelFromJSON(json['ancillary']),
        'apiName': !exists(json, 'apiName') ? undefined : GuidIdAndLabelFromJSON(json['apiName']),
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
    };
}

export function AncillaryManagerListItemToJSON(value?: AncillaryManagerListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'ancillaryCategory': Int32IdAndLabelToJSON(value.ancillaryCategory),
        'ancillary': GuidIdAndLabelToJSON(value.ancillary),
        'apiName': GuidIdAndLabelToJSON(value.apiName),
        'allowEdit': value.allowEdit,
    };
}


